import React from 'react'

import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { EventTypes, getPageSource, track } from '@mc/track-event'

import { FREE_TRIAL_I18N_NAMESPACE } from '../../i18n'
import { useFreeTrial } from '../../lib/useFreeTrial'

export const StickyFooter = () => {
  const { t } = useTranslation(FREE_TRIAL_I18N_NAMESPACE)
  const { trial } = useFreeTrial()

  const onClick = () => {
    track(EventTypes.PURCHASE_CLICK, {
      active_annual_pass: false,
      page_source: getPageSource(),
      page_path: window.location.pathname,
      type: 'all-access-pass',
      class: 'annual-pass',
      location: 'sticky_footer',
      href: paths.checkout,
      action: t('freeTrial.footer.cta'),
    })
  }

  return (
    <div className='mc-bg-primary'>
      <div className='container d-flex justify-content-between justify-content-md-end align-items-center mc-py-4'>
        <div className='mc-mr-4 mc-text--md-right'>
          <p
            className='mc-text--uppercase mc-text--brand d-flex flex-column flex-md-row'
            style={{ fontSize: '28px' }}
          >
            <span className='mc-mr-md-1'>
              {t('freeTrial.footer.title', {
                duration: trial.strings.duration,
              })}
            </span>
            <span>{t('freeTrial.footer.description')}</span>
          </p>
        </div>
        <Button kind='play' as='a' href={paths.checkout} onClick={onClick}>
          {t('freeTrial.footer.cta')}
        </Button>
      </div>
    </div>
  )
}
